import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/logo.png';

const navLinks = [
  { label: 'Home', to: '/' },
  { label: 'Foscan®', to: '/foscan' },
  { label: 'Head & Neck Cancer', to: '/head-neck-cancer' },
  { label: 'Photodynamic Therapy', to: '/pdt' },
  { label: 'Adverse Event Report', to: '/adverse-event-report' },
  { label: 'About', to: '/about' },
];

export default function Navbar() {
  const location = useLocation();

  return (
    <header className="site-header">
      <div className="site-header-inner">
        <Link to="/" className="site-header-logo" aria-label="biolitec pharma — home">
          <img src={logo} alt="biolitec pharma" />
        </Link>

        <nav className="navbar-links" aria-label="Main">
          {navLinks.map((link) => {
            const active = location.pathname === link.to;
            return (
              <Link
                key={link.to}
                to={link.to}
                className={`nav-link${active ? ' nav-link--active' : ''}`}
                aria-current={active ? 'page' : undefined}
              >
                {link.label}
              </Link>
            );
          })}
          <Link to="/contact" className="nav-contact">
            Contact <span aria-hidden="true">→</span>
          </Link>
        </nav>
      </div>
    </header>
  );
}